import Service from "../Service";

const resource = "sfw/medicalhistory/";

export default {
  pagination(dtr) {
    return Service.post(resource + "pagination", dtr);
  },
  listByWorker(PrsDocumentNumber) {
    return Service.get(resource + "getByWorker", { params: { PrsDocumentNumber: PrsDocumentNumber } });
  },
  getDiagnosisTimeline(PrsDocumentNumber, yearsBack = 5) {
    return Service.get(resource + "diagnosisTimeline", {
      params: {
        PrsDocumentNumber,
        yearsBack,
      },
    });
  },
  show(obj) {
    return Service.get(resource + "show", { params: { MevID: obj.MevID } });
  },
  store(obj) {
    return Service.post(resource + "save", obj);
  },
  update(obj) {
    return Service.post(resource + "save", obj);
  },
  getLastHistory(PrsDocumentNumber) {
    // console.log("Getting last history for PrsDocumentNumber:", PrsDocumentNumber);
    
    return Service.get(resource + "getLastHistory", { params: { PrsDocumentNumber: PrsDocumentNumber } });
  },
  /**
   * Devuelve el historial de cambios (todas las versiones) de una historia clínica.
   */
  getHistoryChanges(mevId) {
    return Service.get(resource + "getHistoryChanges", { params: { mevId } });
  },
  pdf(obj) {
    return Service.post(resource + "pdfHistory", obj, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  validateHistory(obj, usrId) {
    // console.log('Validating history with obj:', obj, 'and usrId:', usrId);
    
    return Service.post(resource + "validateHistory", obj , { params: { UsrValidateID: usrId } });
  },
  async getNumerationDocument(docnumber, usrId) {
    // console.log("Getting numeration document:", docnumber, usrId);

    return Service.post(resource + "getNumerationCode",{}, {
      params: { PrsDocumentNumber: docnumber, UsrID: usrId }
    });
  },
  getWorkingConditions(pstId) {
    return Service.get(resource + "getWorkingConditions", { params: { pstId :pstId } });
  }
};